import { ComponentProps } from 'react';

import TMIcon from 'tm-icons-library';

import { HomeRoutes } from '../types/routes';
import { CustomApp } from './HostMetadata';
import { OnboardingStatus } from './userTypes';

export interface IResponseType<T> {
  code: number;
  message: string;
  result: T;
  type: string;
}

export interface ITokens {
  refreshToken: string;
  accessToken: string;
}

export type DRMTypes = 'Widevine' | 'PlayReady' | 'FairPlay';

export interface IDisabledNotificationStates {
  disableEmail: boolean;
  disableWhatsapp: boolean;
  disableNotification: boolean;
}

export interface UploadedUris {
  compressed: string;
  uncompressed: string;
}

export type TMIconsType = ComponentProps<typeof TMIcon>['name'];

export interface CustomRouteConfig {
  title: string;
  path: string;
  shortTitle?: string;
  icon?: TMIconsType;
  apps?: CustomApp[];
  key: string;
}

export interface InitialRoute {
  route: HomeRoutes;
  path: string;
  isTMProject: boolean;
}

export interface ICustomRoute {
  name: HomeRoutes;
  config: CustomRouteConfig;
}

export interface CustomRouter {
  homeRoutes: ICustomRoute[];
  menuRoutes: ICustomRoute[];
  initialRoutes: Partial<Record<OnboardingStatus | 'default', InitialRoute>>;
}

export enum Currency {
  INR = 'INR',
  USD = 'USD',
  EUR = 'EUR',
}

export const Currencies = ['INR', 'USD', 'EUR'] as const;

export type CurrencyType = (typeof Currencies)[number];

export enum LowerCaseCurrency {
  INR = 'inr',
  USD = 'usd',
  EUR = 'eur',
}

export enum LocalStorageKeys {
  VERIFY_STATUS = 'verifyStatus',
  AFTER_LOGIN_REDIRECT_TO = 'afterLoginRedirectTo',
  REFRESH_TOKEN_KEY = 'token',
}

export enum NotificationType {
  PAYMENT_TRANSFER = 'payment_transfer',
  VIDEO_CALL_REQUEST = 'videocall_request',
  VIDEO_CALL_ACCEPTED = 'videocall_accepted',
  WEBINAR_CREATED = 'webinar_created',
  WEBINAR_STARTED = 'webinar_started',
  BEFORE_WEBINAR = 'before_webinar',
  NEW_MESSAGE = 'new_message',
  NEW_POST_UPDATE = 'new_post_update',
  LIKES_COMMENTS = 'likes_comments',
  CAMPAIGN = 'campaign',
  NEW_CONTENT = 'new_content',
  NEW_SUBSCRIPTION = 'new_subscription',
  NEW_PURCHASE = 'new_purchase',
  MENTION = 'mention',
  NEW_COMMENT = 'new_comment',
  NEW_CHANNEL_POST = 'new_channel_post',
  NEW_CHANNEL_POST_LIKE = 'new_channel_post_like',
  NEW_CHANNEL_POST_COMMENT = 'new_channel_post_comment',
  NEW_CHANNEL_POST_COMMENT_LIKE = 'new_channel_post_comment_like',
  NEW_CHANNEL_POST_COMMENT_REPLY = 'new_channel_post_comment_reply',
  NEW_CHANNEL_POST_COMMENT_MENTION = 'new_channel_post_comment_mention',
}
